export default __webpack_public_path__ + "static/media/ddqic.44488b46.jpg";